const MINIMUM_FUZZY_MATCH_LENGTH = 3;

export function normalizeRuleText(value?: string | null) {
  return (value ?? '').trim().toLowerCase();
}

export function hasRuleValue(value?: string | null) {
  return !!normalizeRuleText(value);
}

export function uniqueNormalizedValues(values: Array<string | null | undefined>) {
  return Array.from(new Set(values.map((value) => normalizeRuleText(value)).filter(Boolean)));
}

export function fuzzyValuesMatch(left?: string | null, right?: string | null) {
  const normalisedLeft = normalizeRuleText(left);
  const normalisedRight = normalizeRuleText(right);
  const allowFuzzyMatch =
    normalisedLeft.length >= MINIMUM_FUZZY_MATCH_LENGTH && normalisedRight.length >= MINIMUM_FUZZY_MATCH_LENGTH;

  return (
    !!normalisedLeft &&
    !!normalisedRight &&
    (normalisedLeft === normalisedRight ||
      (allowFuzzyMatch && (normalisedLeft.includes(normalisedRight) || normalisedRight.includes(normalisedLeft))))
  );
}
